import { useState } from "react";
import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function LatestSection() {
  const [filter, setFilter] = useState("all");
  const tags = ["all", "fantasy", "romance", "action", "thriller", "horror", "drama"];

  const filtered = filter === "all"
    ? comics
    : comics.filter((c) => c.category === filter);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              最新韩国漫画推荐
            </h2>
            <p className="text-foreground-500 text-sm">
              持续更新<strong>好看的韩国漫画大全</strong>，不错过任何精彩
            </p>
          </div>
        </div>

        <div className="flex gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
          {tags.map((tag) => {
            const label = tag === "all" ? "全部" : tag === "fantasy" ? "奇幻" : tag === "romance" ? "恋爱" : tag === "action" ? "动作" : tag === "thriller" ? "悬疑" : tag === "horror" ? "恐怖" : "剧情";
            return (
              <button
                key={tag}
                onClick={() => setFilter(tag)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                  filter === tag
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-600 hover:bg-background-200/70 border border-background-200/70"
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:shadow-sm transition-all cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-black/60 text-background-50 text-xs">
                  {comic.status}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-semibold text-sm text-foreground-950 mb-1 group-hover:text-primary-700 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                  <span className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-yellow-400 w-3 h-3 flex items-center justify-center"></i>
                    {comic.rating}
                  </span>
                  <span>{comic.chapters}话</span>
                </div>
                <div className="flex gap-1 flex-wrap">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}